import Head from "next/head";
import styles from "../tnpsc-group-i-prelims-test/tnpsc-group-i-prelims-test.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
import Image from "next/image";
import SIwebbanner from "../../assets/images/home/Banner/SI-Test-Series-Webbanner.jpg";
import SIMobbanner from "../../assets/images/home/Mob_Banner/SI-Test-Series-Mobilebanner.jpg";
const Interest = dynamic(() => import("../../components/might-be-interest"));

import Link from "next/link";

const Tnpsc_Group_One_Prelims_Test_series = () => {
    return (
        <>

            <Head>
                <meta charset="UTF-8" />
                <link rel="icon" href="./logo.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>TNUSRB-SI Test Series 2024 - Shankar IAS Academy</title>
                <meta name="title" content="TNUSRB-SI Test Series 2024 - Shankar IAS Academy" />
                <meta name="description" content="We are conducting TNPSC Group Ⅰ Prelims Test for TNPSC - Practice for TNPSC Prelims Revision and taking mock tests in an Exam - Shankar IAS Academy" />
                <link rel="canonical" href="https://www.shankariasacademy.com/si-test-series/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="TNUSRB-SI Test Series 2024 - Shankar IAS Academy" />
                <meta property="og:description" content="We are conducting TNPSC Group Ⅰ Prelims Test for TNPSC - Practice for TNPSC Prelims Revision and taking mock tests in an Exam - Shankar IAS Academy" />
                <meta property="og:url" content="https://www.shankariasacademy.com/si-test-series/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

            <Navbar title="tnpsc" />
            <div className="container">
        <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={SIwebbanner}
                alt="orientation banner"
                title="UPSC orientation Test Series 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

          <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={SIMobbanner}
                alt="orientation banner"
                title="UPSC orientation"
                className="img-fluid w-100"
              />
            </div>
          </div>
      </div>

            <div className="container">

                <div className="row">
                    <div className="col">
                    <h1 className={`${styles.sectiontitle}`} style={{color:"#db1b0d"}}>TNUSRB-SI Test Series 2024</h1>
                </div>
                </div>
                <div className="row d-none d-md-block">
                    
                </div>

                <div className="row d-block d-md-none">
                    
                </div>
            </div>


            {/* table */}

            <div className="container d-none d-lg-block">
                <div className="row pt-3 prelimstable">
                
                    <div className="col">
                        <div className={`${styles.tablescroll}`}>
                            <table class="table">
                                <thead class="table" style={{ backgroundColor: "#818C98" }}>
                                    <tr>
                                        <td className={`${styles.tableheading}`}>Center<br /></td>
                                        <td className={`${styles.tableheading}`}>Mode<br /></td>
                                        <td className={`${styles.tableheading}`}>Starts on<br /></td>
                                        <td className={`${styles.tableheading}`}>Fee<br /></td>
                                        <td className={`${styles.tableheading}`}>Schedule<br /></td>
                                        <td className={`${styles.tableheading}`}>Instruction<br /></td>
                                        <td className={`${styles.tableheading}`}>Payment<br /></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline/Online)<br /></td>
                                        <td className={`${styles.tablepara}`}>15th May 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students & Online Student)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Offline Students)</p></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Test-Schedule-Batch1-Annanagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton1}`} type="submit">Pay Here</button></Link></td>
                                    </tr>
                                  
                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Trichy<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline)<br /></td>
                                        <td className={`${styles.tablepara}`}>17th May 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Students)</p></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-TEST-BATCH1-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton1}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Madurai<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline)<br /></td>
                                        <td className={`${styles.tablepara}`}>18th May 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Students)</p></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-TEST-BATCH 1-SCHEDULE-MADURAI.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton1}`} type="submit">Pay Here</button></Link></td>
                                    </tr>


                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Salem<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline)<br /></td>
                                        <td className={`${styles.tablepara}`}>19th May 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Students)</p></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-BATCH-UPDATED-SCHEDULE-SALEM.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton1}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Namakkal<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline)<br /></td>
                                        <td className={`${styles.tablepara}`}>22nd May 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Students)</p></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-BATCH1-SCHEDULE - NAMAKKAL.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton1}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Thiruvarur<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline)<br /></td>
                                        <td className={`${styles.tablepara}`}>18th May 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Students)</p></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-TEST-BATCH1-SCHEDULE-THIRUVARUR.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton1}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Coimbatore<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline)<br /></td>
                                        <td className={`${styles.tablepara}`}>16th June 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Students)</p></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Test-Schedule-Batch1-Coimbatore.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton1}`} type="submit">Pay Here</button></Link></td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* mobile view table*/}
            <div className="container d-lg-none">
           
                <div className="">
                    <hr />
                    <p className={`${styles.mbtableheading} `}>Chennai - Anna Nagar<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular (Offline/Online)</p>
                    <p className={`${styles.tablepara}`}>15th May 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new students & Online Student)<br /> ₹4500 (For Old - Offline Students)</p>
                    <div> <p className={`${styles.tablepara}`}> Schedule - <Link href="/pdf/SI-Test-Batch-2024/SI-Test-Schedule-Batch1-Annanagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p> </div>
                    <div> <p className={`${styles.tablepara}`}> Instruction -<Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p></div>
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

                <div className="">
                    <hr />  
                    <p className={`${styles.mbtableheading} `}>Trichy<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular (Offline)</p>
                    <p className={`${styles.tablepara}`}>17th May 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new - students)<br /> ₹4500 (For Old Students)</p>
                    <div> <p className={`${styles.tablepara}`}> Schedule - <Link href="/pdf/SI-Test-Batch-2024/SI-TEST-BATCH1-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p> </div>
                    <div> <p className={`${styles.tablepara}`}> Instruction -<Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p></div>
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

                <div className="">
                    <hr />  
                    <p className={`${styles.mbtableheading} `}>Salem<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular (Offline)</p>
                    <p className={`${styles.tablepara}`}>19th May 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new - students)<br /> ₹4500 (For Old Students)</p>
                    <div> <p className={`${styles.tablepara}`}> Schedule - <Link href="/pdf/SI-Test-Batch-2024/SI-Test-batch-schedule-Salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p> </div>
                    
                    <div> <p className={`${styles.tablepara}`}> Instruction -<Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p></div>
                    
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

                <div className="">
                    <hr />  
                    <p className={`${styles.mbtableheading} `}>Namakkal<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular (Offline)</p>
                    <p className={`${styles.tablepara}`}>22nd May 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new - students)<br /> ₹4500 (For Old Students)</p>
                    <div> <p className={`${styles.tablepara}`}> Schedule - <Link href="/pdf/SI-Test-Batch-2024/SI-BATCH1-SCHEDULE - NAMAKKAL.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p> </div>
                    
                    <div> <p className={`${styles.tablepara}`}> Instruction -<Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p></div>
                    
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

                <div className="">
                    <hr />  
                    <p className={`${styles.mbtableheading} `}>Madurai<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular (Offline)</p>
                    <p className={`${styles.tablepara}`}>18th May 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new - students)<br /> ₹4500 (For Old Students)</p>
                    <div> <p className={`${styles.tablepara}`}> Schedule - <Link href="/pdf/SI-Test-Batch-2024/SI-TEST-BATCH 1-SCHEDULE-MADURAI.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p> </div>
                    
                    <div> <p className={`${styles.tablepara}`}> Instruction -<Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p></div>
                    
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

                <div className="">
                    <hr />  
                    <p className={`${styles.mbtableheading} `}>Thiruvarur<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular (Offline)</p>
                    <p className={`${styles.tablepara}`}>18th May 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new - students)<br /> ₹4500 (For Old Students)</p>
                    <div> <p className={`${styles.tablepara}`}> Schedule - <Link href="/pdf/SI-Test-Batch-2024/SI-TEST-BATCH1-SCHEDULE-THIRUVARUR.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p> </div>
                    
                    <div> <p className={`${styles.tablepara}`}> Instruction -<Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p></div>
                    
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

                <div className="">
                    <hr />  
                    <p className={`${styles.mbtableheading} `}>Coimbatore<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular (Offline)</p>
                    <p className={`${styles.tablepara}`}>16th June 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new - students)<br /> ₹4500 (For Old Students)</p>
                    <div> <p className={`${styles.tablepara}`}> Schedule - <Link href="/pdf/SI-Test-Batch-2024/SI-Test-Schedule-Batch1-Coimbatore.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p> </div>
                    
                    <div> <p className={`${styles.tablepara}`}> Instruction -<Link href="/pdf/SI-Test-Batch-2024/SI-Instruction-Online-and-Offline-Candidates.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></p></div>
                    
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

              
                
            </div>
            <Interest />
            <Footer />
        </>
    )
}
export default Tnpsc_Group_One_Prelims_Test_series;
